import my_Case from "../../asset/images/project_images/my_Case.png"
import exam_login from "../../asset/images/project_images/exam_login.png"
import business_headlines from "../../asset/images/project_images/business_headlines.png"
import bulksms from "../../asset/images/project_images/bulksms.png"

import React from "react";


export default function Project() {
    const MTT = "https://mytraffictickets.com";
    return (
        <div className={"brijesh_wrapper ps-0"}>
            <div className={"container section_title_main pt-lg-5 pt-0 mt-5 project_wrapper"} id={"project"}>
                <h3 className={"section_title  mt-0 pt-0 pt-lg-5 mt-lg-5"}>Projects</h3>
                <div className={'row px-lg-4 px-0 mx-lg-4 mx-3'}>
                    <div className={"col-lg-5 col-md-6 project_card_single"}>
                        <div className={"project_card"}>
                            <img src={my_Case} className={"project_img"} alt="project google iage"/>
                            <div className={"title_main"}>
                                <h4 className={"project_title"}>My Traffic Ticket</h4>
                                <div className={"title_bottom_row"}></div>
                            </div>
                            <p className={"project_discriptions"}>My Traffic Tickets (USA) platform is provide Lawyers for your Traffic Ticket Case.this site buid with React js.</p>
                            <button type="button" className={"lookit_up_btn"}>
                                <a href={MTT} target={"_blank"} style={{color:"white"}} className={"link_project"}>Look it up</a>
                            </button>
                        </div>
                    </div>
                    <div className={"col-lg-2  mt-0 pt-0 d-lg-block d-none"}></div>
                    <div className={"col-lg-5 col-md-6 project_card_single"}>
                        <div className={"project_card"}>
                            <img src={exam_login} className={"project_img"} alt="project google iage"/>
                            <div className={"title_main"}>
                                <h4 className={"project_title"}>Exam Portal</h4>
                                <div className={"title_bottom_row"}></div>
                            </div>
                            <p className={"project_discriptions"}>Exam Portal is provide test for student's which in this panel people also check perfomance report and improvment.</p>
                            <button type="button" disabled className={"lookit_up_btn cursor-text"} style={{cursor:"unset"}}>
                                <a style={{color:"white"}} disabled className={"link_project cursor-text"}>Private site</a>
                            </button>
                        </div>
                    </div>
                    <div className={"col-lg-5 col-md-6 project_card_single"}>
                        <div className={"project_card"}>
                            <img src={business_headlines} className={"project_img"} alt="project google iage"/>
                            <div className={"title_main"}>
                                <h4 className={"project_title"}>News Site</h4>
                                <div className={"title_bottom_row"}></div>
                            </div>
                            <p className={"project_discriptions"}> I have develop this site for one of my friends he is an Journalism.This site develop with react js.</p>
                            <button type="button" disabled className={"lookit_up_btn cursor-text"} style={{cursor:"unset"}}>
                                <a style={{color:"white"}} disabled className={"link_project cursor-text"}>Private site</a>
                            </button>
                        </div>
                    </div>
                    <div className={"col-lg-2 d-lg-block d-none"}></div>
                    <div className={"col-lg-5 col-md-6 project_card_single"}>
                        <div className={"project_card"}>
                            <img src={bulksms} className={"project_img"} alt="project google iage"/>
                            <div className={"title_main"}>
                                <h4 className={"project_title"}>Bulksmsplans</h4>
                                <div className={"title_bottom_row"}></div>
                            </div>
                            <p className={"project_discriptions"}>Bulksmsplans Offering top-class Bulk SMS Gateway in Egypt at a very affordable rate which can fix in your budget.</p>
                            <button type="button" className={"lookit_up_btn"}>
                                <a style={{color:"white"}} href={"https://www.bulksmsplans.com"} target={"_blank"} className={"link_project"}>Look it up</a>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    )
}